import { TFunction } from "i18n";
import { getTagminSelfTapeUrl } from "pages/SelfTapeRequestPage/SelfTapeRequestAgentParts/helpers";

export interface IGetCancelButtonProps {
  selfTapeRequestId: string;
  isAccepted?: boolean;
  forwardedToPerformer?: boolean;
  isTagminUser?: boolean;
  t: TFunction;
  showModal: () => void;
}

export function getAgentCancelButton({
  selfTapeRequestId,
  isAccepted,
  forwardedToPerformer,
  isTagminUser,
  showModal,
  t,
}: IGetCancelButtonProps) {
  if (isAccepted && !forwardedToPerformer) {
    return {
      text: t("common:selfTapes.request.action.sendToClient"),
      onClick: showModal,
    };
  }

  if (isTagminUser) {
    return {
      text: t("common:selfTapes.request.action.openInTagmin"),
      onClick: () =>
        window.open(getTagminSelfTapeUrl(selfTapeRequestId), "_blank"),
    };
  }
}
